import { render } from "./PreviewInvoice.vue?vue&type=template&id=387b9dee&scoped=true"
import script from "./PreviewInvoice.vue?vue&type=script&lang=js"
export * from "./PreviewInvoice.vue?vue&type=script&lang=js"

import "./PreviewInvoice.vue?vue&type=style&index=0&id=387b9dee&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387b9dee"]])

export default __exports__